import { defineStore } from "pinia";

export const useToastStore = defineStore("toast", {
  state: () => ({
    visible: false as boolean,
    message: "" as string,
    type: "" as string, // success, error, loading
    timer: null as number | null,
  }),
  actions: {
    showToast(msg: string, toastType = "", duration = 2000) {
      this.message = msg;
      this.type = toastType;
      this.visible = true;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      if (toastType !== "loading") {
        this.timer = window.setTimeout(() => {
          this.visible = false;
          this.timer = null;
        }, duration) as unknown as number;
      }
    },
    showErrorCodeToast(code: any = 'common', t: any) {
      const errorKey = "error." + code;
      const message =
        t(errorKey) === String(code) ? t("error.common") : t(errorKey);
      this.showToast(`${message}【${code}】`, "error", 3500);
    },
    hideToast() {
      this.visible = false;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
  },
});
